/* eslint-disable prettier/prettier */
import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  toolbarContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '90px',
    margin: theme.spacing(2),
    borderRadius: '25px'
  },
  paper: {
    position: 'absolute',
    display: 'flex',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },
  toolbarMobileContainer: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '60px',
    margin: theme.spacing(2),
    borderRadius: '25px'
  },
  miniToolbarContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    bottom: 8,
    left: 8,
    right: 8,
    height: '48px',
    margin: 0,
    borderRadius: '16px',
    backgroundColor: 'transparent'
},
miniToolbarButton: {
  margin: theme.spacing(0.5),
  borderRadius: '50%',
  backgroundColor: '#ED7801',
  color: '#fff',
  width: 36,
  height: 36,
  minWidth: 36,
  minHeight: 36,
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.2rem',
  boxShadow: theme.shadows[2],
  transition: 'background 0.2s',
  '&:hover': {
    backgroundColor: '#d96d00'
  }
},
  toolbarButtons: {
    margin: theme.spacing(1),
    borderRadius: '5em',
    backgroundColor: '#ED7801',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#d96d00'
    }
  },
  arrowButton: {
    borderRadius: '5em',
    height: '50px',
    width: '50px',
    backgroundColor: '#081d2e',
    color: '#fff',
      '&:hover': {
      backgroundColor: theme.palette.action.active
    }
  },
  infoButton: {
    position: 'absolute',
    left: '0',
    margin: theme.spacing(1),
    borderRadius: '5em',
    height: '50px',
    width: '50px',
    backgroundColor: '#081d2e',
    color: '#fff',
     '&:hover': {
    backgroundColor: '#092a45'
    }
  },
  groupButton: {
    margin: '8px'
  },
  disabledButton: {
    backgroundColor: theme.palette.action.active,
    '&:hover': {
      backgroundColor: '#081d2e'
    }
  },
  activeButton: {
    backgroundColor: theme.palette.action.active,
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  activeButtonIcon: {
    color: theme.palette.action.active
  },
  transcriptPreview: {
    position: 'absolute',
    bottom: '100%',
    right: '15%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    padding: '10px',
    borderRadius: '8px',
    maxWidth: '400px',
    maxHeight: '150px',
    overflowY: 'auto',
    zIndex: 1000,
    scrollBehavior: 'smooth', // Adiciona rolagem suave
    '&::-webkit-scrollbar': {
      width: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderRadius: '3px'
    }
  },
  reactionContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    animation: '$fadeOut 2s ease forwards',
    pointerEvents: 'none', // Evita interferência no clique
    zIndex: 1000,
    fontSize: '4rem'
  },
  reactionEmoji: {
    fontSize: '4rem'
  },
  '@keyframes fadeOut': {
    '0%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' },
    '100%': { opacity: 0, transform: 'translate(-50%, -50%) scale(1.5)' }
  }
}))